import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { type ProductCardFormType } from '@web/widgets/product-card/type';
import { TranslateModule } from '@ngx-translate/core';
import { WebEditorModule } from '@web/shared/components/web-editor/web-editor.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'web-product-name',
    templateUrl: './product-name.component.html',
    styleUrls: ['./product-name.component.less'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [FormsModule, ReactiveFormsModule, WebEditorModule, TranslateModule],
})
export class ProductNameComponent {
    @Input() name: ProductCardFormType['name'];
    @Input() description: ProductCardFormType['description'];
    @Input() shortDescription: ProductCardFormType['shortDescription'];

    public readonly DESCRIPTION_MAX_LENGTH: number = 5000;
    public readonly SHORT_DESCRIPTION_MAX_LENGTH: number = 200;
}
